import React, { Component } from 'react';
import _ from 'lodash';
import { reactLocalStorage } from 'reactjs-localstorage';
import ReduxToastr, { toastr } from 'react-redux-toastr';
import Router from '../../config/router';
import Dropdown from '../Elements/Dropdown';
import { langs } from "../../config/localization";
import { connect } from "react-redux";
import {isUserLoggedIn, getAuthUserFullName, getAuthUserProfilePic} from "../../actions/Common";
import {API_URL, APP_URL, DEFAULT_USER_IMAGE} from "../../config/config";
import {eventTracking} from "../../actions/UserAction";


class Layout extends Component {
  constructor(props) {
      super(props);
      //this.eventTrackings = this.eventTrackings.bind(this);
  }
    /**
     * Logout
     */
    logout = () => {
        /* Action tracking */
        let originRoute = document.referrer;
        let destinationRoute = window.location.href;
        let date = new Date();
        let postData = {type: 'LoggedOut', originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
        this.props.eventTracking(postData);
        /* Action tracking */

        reactLocalStorage.clear();
        window.location.assign('/login');
    }

    eventTrackings = (eventData) => {
      /* Action tracking */
      let originRoute = document.referrer;
      let destinationRoute = window.location.href;
      let date = new Date();
      let postData = {type: eventData, originRoute: originRoute, destinationRoute: destinationRoute, timestamp: date};
      this.props.eventTracking(postData);
      /* Action tracking */
    }

    /**
     * Switch layout based on the current url
     * @returns {*}
     */
    switchLayout() {
        const { tagCloudDetail } = this.props;
        let currentUrl = window.location.pathname;
        //if(currentUrl == '/' || currentUrl.includes('tag-cloud') || currentUrl.includes('donate-mobile')){
        if(currentUrl.includes('tag-cloud') || currentUrl.includes('donate-mobile')){
            return(
                <div className="">
                    <Router />
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="bottom-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar />
                </div>
            )
        } /*else if(currentUrl == '/') {
            //Don't show menu for splash page
            return (
                <div className="auth-pages">
                    <header className="site-header">
                        <div className="row">
                            <div className="columns medium-12">
                                <div className="logo-wrapper">
                                    <a href="/"><img src="/assets/images/eathdeck/logo.png" className="header-logo" /></a>
                                </div>
                            </div>
                        </div>
                    </header>
                    <div className="">
                        <Router />
                    </div>
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="bottom-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar />
                </div>
            )
        }*/ else if(!isUserLoggedIn()){
            return (
                <div className="auth-pages">
                    <header className="site-header">
                    <div className="row">
                        <div className="columns medium-12">
                            <div className="logo-wrapper">
                                <a href="/"><img src="/assets/images/eathdeck/logo.png" className="header-logo" /></a>
                            </div>
                            <nav className="main-navigation">
                                <ul id="menu-tnb" className="menu">
                                    <li><a href="https://www.oceanfdn.org/donate/earthdecksorg-ocean-network" target='_blank' onClick={ this.eventTrackings.bind(this, 'DonateButtonPressed') } className="btn-primary secondary-gradient-bg"><img src="/assets/images/eathdeck/donate_icon.png" /> Donate</a></li>
                                    <li><a href="/login" className={(currentUrl.includes('login')? "btn-primary primary-gradient-bg":"login")}>Login</a></li>
                                    <li><a href="/signup" className={((currentUrl.includes('signup')|| currentUrl.includes('profile-questions'))? "btn-primary primary-gradient-bg":"login")}>Signup</a></li>
                                </ul>
                            </nav>
                        </div>
                        </div>
                    </header>
                    <div className="">
                        <Router />
                    </div>
                    {this.renderFooter()}
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="bottom-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar />
                </div>
            )
        }else if(!isUserLoggedIn() && (currentUrl.includes('tag-cloud') || currentUrl.includes(''))){
            return (
                <div>
                    <Router />
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="bottom-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar />
                </div>
            )
        } else if( isUserLoggedIn() || tagCloudDetail !== undefined) {
            return (
                <div className="wrapper">
                    <header className="site-header">
                    <div className="row">
                        <div className="columns medium-12">
                            <div className="logo-wrapper">
                                <a href="/dashboard"><img src="/assets/images/eathdeck/logo.png" className="header-logo" /></a>
                            </div>
                            <nav className="main-navigation">
                                <ul id="menu-tnb" className="menu">
                                    <li><a href="https://www.oceanfdn.org/donate/earthdecksorg-ocean-network" target='_blank' onClick={ this.eventTrackings.bind(this, 'DonateButtonPressed') } className="btn-primary secondary-gradient-bg"><img src="/assets/images/eathdeck/donate_icon.png" /> Donate</a></li>
                                    {/* <li><a href="/login" className="login">Login</a></li>
                                    <li><a href="/signup" className="btn-primary primary-gradient-bg">Signup</a></li> */}
                                    <li className="profile-pic">
                                        <Dropdown Title={this.userIconView()}>
                                            <ul className="dropdown-menu-list">
                                                <li>
                                                    <a href="/dashboard" className="nav-link">
                                                        <img src="/assets/images/eathdeck/dashboard.png" /> My earthDECK
                                                    </a>
                                                    <a
                                                        href="/edit-profile"
                                                        className="nav-link"
                                                        onClick={ this.eventTrackings.bind(this, 'ViewProfileSelected') }
                                                    >
                                                        <img src="/assets/images/eathdeck/profile_edit.png" /> Edit Profile
                                                    </a>
                                                    <a
                                                        className="nav-link"
                                                        onClick={ this.eventTrackings.bind(this, 'CreateNewCloudSelected') }
                                                        href="/user-guide-video"
                                                    >
                                                        <img src="/assets/images/eathdeck/new_earthdecks.png" /> New earthDECK
                                                    </a>
                                                    <a
                                                        className="nav-link"
                                                        onClick={ this.eventTrackings.bind(this, 'AboutSelected') }
                                                        href="/about"
                                                    >
                                                        <img src="/assets/images/eathdeck/about.png" /> About
                                                    </a>
                                                    <a
                                                        className="nav-link"
                                                        onClick={ this.eventTrackings.bind(this, 'IncentiveSelected') }
                                                        href="/incentive"
                                                    >
                                                        <strong style={{marginRight: '10px'}}>
                                                            &#127942;
                                                        </strong> Incentive Awards
                                                    </a>
                                                    <a
                                                        className="nav-link"
                                                        onClick={this.logout.bind(this)}
                                                        href="javascript:void(0);"
                                                    >
                                                        <img src="/assets/images/eathdeck/logout.png" /> Logout
                                                    </a>
                                                </li>
                                            </ul>
                                        </Dropdown>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        </div>
                    </header>
                    <Router />
                    {this.renderFooter()}
                    <ReduxToastr
                        timeOut={5000}
                        newestOnTop={false}
                        preventDuplicates
                        position="bottom-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar
                    />
                </div>
            )
        }
    }

  /**
   * Footer Html
   * @returns {*}
   */
    renderFooter() {
      let currentUrl = window.location.href;

      if(!currentUrl.includes('home')
        && !currentUrl.includes('user-guide')
        && !currentUrl.includes('user-guid-video')
        && !currentUrl.includes('registration-success')
        && !currentUrl.includes('about') ) {
        return(
          <footer className="ed-footer">
              <div className="row">
                  <div className="footer-top">
                      <div className="row">
                          <div className="medium-6 columns">
                              <p>Connect with us</p>
                              <ul>
                                  <li><a href="https://www.linkedin.com/company/earthdecks/" target="_blank"><i className="fa fa-linkedin"></i></a></li>
                                  <li><a href="https://www.facebook.com/earthdecks/" target="_blank"><i className="fa fa-facebook" ></i></a></li>
                                  <li><a href="https://twitter.com/earthdecks/" target="_blank"><i className="fa fa-twitter"></i></a></li>
                                  {/*<li><a href="#"><i className="fa fa-google-plus"></i></a></li>*/}
                                  <li><a href="https://www.instagram.com/earthDECKS/" target="_blank"><i className="fa fa-instagram"></i></a></li>
                              </ul>
                          </div>
                          <div className="medium-6 columns text-right">
                              <p className="copyright">Copyright @ {(new Date().getFullYear() - 1)} - {(new Date().getFullYear())} earthDECKS</p>
                          </div>
                      </div>
                  </div>
              </div>
          </footer>
        )
      }
    }

    /**
     * Profile pic HTML
     * @returns {*}
     */
    userIconView() {
        const userFullName = getAuthUserFullName();
        const userProfilePic = getAuthUserProfilePic();
        const fullName = userFullName != '' ? userFullName : 'Admin';
        let avatarImage = (typeof userProfilePic != 'undefined' && (userProfilePic != ''))?(APP_URL + userProfilePic):DEFAULT_USER_IMAGE;

        return (
            <span style={{ backgroundImage: "url("+avatarImage+")"}}><img src="/assets/images/eathdeck/gradient-icon.png" /></span>
        )
    }

    /**
     * Print Notification text and Number of Notification
     * @returns {*}
     */
    notificationNav() {
        return (
            <span className="item"><span>{langs.notifications}</span>&nbsp;<span className="notification">3</span></span>
        )
    }

    /**
     * Get currently active menu
     * @returns {string}
     */
    getActiveMenu() {
        let currentUrl = window.location.href;
        let activePage = '';

        if (currentUrl == undefined) {
            activePage = 'post';
        }

        return activePage;
    }

    /**
     * Authenticated user's navigation HTML
     * @returns {*}
     */
    authenticatedUserNav() {
        const activePage = this.getActiveMenu();
        return (
            <ul className="navbar">
                {this.commonUserNav()}
                <li className="user-profile">
                    <Dropdown Title={this.userIconView()} ToggleDropdown={false}>
                        <ul className="dropdown-menu-list">
                            <li>
                                <a className="nav-link" href="/edit-profile">{langs.edit_profile}</a>
                                <a className="nav-link" onClick={this.logout.bind(this)} href="javascript:void(0);">{langs.logout}</a>
                            </li>
                        </ul>
                    </Dropdown>
                </li>
            </ul>
        );
    }

    /**
     * Common navigation HTML for both authneticated and non authenticated users
     * @returns {*}
     */
    commonUserNav() {
        const activePage = this.getActiveMenu();
        return (
            <ul className="navbar">
                <li><a href="/" className={activePage === 'post' ? 'active nav-link' : 'nav-link'}>Post</a></li>
                {this.unAuthenticatedUserNav()}
            </ul>
        );
    }

    /**
     * Unauthenticated user's navigation HTML
     * @returns {*}
     */
    unAuthenticatedUserNav() {
        if (!isUserLoggedIn()) {
            const activePage = this.getActiveMenu();
            return (
                <li><a href="/login" className={activePage === 'login' ? 'active nav-link' : 'nav-link'}>{langs.login_for_nav}</a></li>
            );
        }
    }

    /**
     * Prepare menu bar html
     * @returns {*}
     */
    menuBar() {
        //if (!_.isEmpty(reactLocalStorage.getObject("user_auth_details"))) {
        if (isUserLoggedIn()) {
            return this.authenticatedUserNav();
        } else {
            return this.commonUserNav();
        }
    }

    /**
     * Render the component
     * @returns {*}
     */
    render() {
        return (
            this.switchLayout()
        );
    }
}


const mapStateToProps = ({dashboard}) => {
    let returnObj = {};
    returnObj.tagCloudDetail = dashboard.tagCloudDetail;
  return returnObj;
}

//Connect action to component
export default connect(mapStateToProps, {eventTracking})(Layout)



// WEBPACK FOOTER //
// ./components/Layout/Master.js